import { useQuery } from '@tanstack/react-query';

import { getUniversityCourseSelect, globalConst, ISecondRoot } from '..';

export const useUniversityCourseBySlug = ({
  courseSlug,
  universitySlug
}: {
  courseSlug?: string;
  universitySlug?: string;
}) => {
  const { data, ...args } = useQuery<{ univerCourse: ISecondRoot }>({
    queryKey: [globalConst.queryKeys.GET_UNIVERSITY_COURSE_SELECT_BY_SLUG, { courseSlug, universitySlug }],
    queryFn: getUniversityCourseSelect({ courseSlug, universitySlug }),
  });

  return { ...data, ...args };
};
